<template>
  <div class="mobile_contentBox">
    <div class="contentStitle">News Information</div>
    <div class="contentTitle">新闻资讯</div>
    <div class="information">
      <div class="information_title">
        <div class="title_left">深圳市云久鸿劳务派遣有限公司简介</div>
        <div class="title_right">></div>
      </div>
      <div class="information_introduce">
        <div class="introduce_left">
          <img :src="src.qyfw" alt="" />
          <p>
            深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
          </p>
          <p>
            云久鸿始终秉持着
            <span class="red">诚信、责任、共赢、感恩</span>
            的企业价值观，以
            <span class="red">用心服务，筑就行业新高度</span>
            为使命，为
            <span class="red">打造值得全球信赖的就业服务平台</span>
            而不懈努力。
          </p>
          <p>
            经过10余年的发展，云久鸿已成为人力资源行业的领先企业，被深圳龙华区人民政府评定为服务业百强企业。
          </p>
          <p>
            现设云久鸿劳务派遣有限公司、云久鸿人力资源有限公司、景上鸿劳务派遣有限公司、云富鸿人力资源有限公司、蓝聘人力资源有限公司等多家子公司，并在深圳各个区设立了多家线下门店。
          </p>
          <p>
            迄今为止，公司已服务企业客户达500多家，为富士康、比亚迪、伯恩光学、天马微等多家500强名企输送数以万计的人力资源。
          </p>
        </div>
      </div>
      <!-- <div class="newTab"></div> -->
      <div class="itemList" v-if="newsList.length > 0">
        <div
          class="item"
          v-for="(item, index) in newsList"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="itemLeft">
            <!-- {{ index + 1 }} -->
            <div class="num">{{ index + 1 }}</div>
            <div class="time">{{ item.created_at }}</div>
          </div>
          <div class="itemRight">
            <div class="itemTitle">{{ item.title }}</div>
            <div class="itemContent">
              {{ item.sub_title }}
            </div>
          </div>
        </div>
      </div>
      <!-- <el-pagination
        small
        layout="prev, pager, next,total"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        hide-on-single-page
        :pager-count="5"
        :page-sizes="pageSizeOptions"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
import src from '../../../utils/assets'
export default {
  data() {
    return {
      src:src,
      form: {
        type: 0,
        category_id: 0,
        page: 1,
        limit: 15,
      },
      pageSize: 15,
      current: 1,
      total: 0,
      pageSizeOptions: ["15", "25", "50", "100"],
      newsList: [],
    };
  },
  created() {
    this.getNewsList();
    // this.getNewsType();
  },
  mounted() {},
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/newsMobileDetails",
        query: {
          id: id,
        },
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    getNewsList() {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/index", { params: _this.form })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.newsList = res.data.data.data;
            _this.total = res.data.data.total;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // getNewsType() {
    //   const _this = this;
    //   axios
    //     .get(process.env.VUE_APP_URL + "/api/news/category?limit=" + _this.limit)
    //     .then(function (res) {
    //       console.log(res);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
  },
};
</script>

<style lang="less" scoped>
.information {
  width: 330px;
  margin: 10px auto;
  .information_title {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #da261d;
    font-size: 20px;
    line-height: 30px;
    .title_right {
      color: #da261d;
      font-weight: 700;
    }
  }
  .introduce_left {
    margin-top: 10px;
    img {
      float: right; /* 对图片进行浮动就可以实现了  */
      width: 150px;
      margin-left: 10px;
    }
    p {
      font-size: 12px;
      text-align: left;
      line-height: 18px;
      text-indent: 20px;
    }
  }
}
.itemList {
  .item {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    // padding: 5px 0;
    border: 1px solid #cccccc;
    padding-bottom: 10px;
    .itemLeft {
      width: 70px;
      border-bottom: 1px solid #cccccc;
      border-right: 1px solid #cccccc;
      .num {
        background-color: #fff;
        // height: 80%;
        // margin-top: -5px;
        background-color: #cccccc;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
      }
      .time {
        font-size: 12px;
        transform: scale(0.8);
        color: #cccccc;
      }
    }
    .itemRight {
      width: 240px;
      text-align: left;
      color: #cccccc;
      .itemTitle {
        margin: 5px 0;
        font-weight: 700;
        font-size: 16px;
      }
      .itemContent {
        line-height: 16px;
      }
    }
  }
  .item:hover {
    border: 1px solid #da261d;
    .itemLeft {
      border-bottom: 1px solid #da261d;
      border-right: 1px solid #da261d;
      .num {
        background-color: #da261d;
      }
      .time {
        color: #da261d;
      }
    }
    .itemRight {
      .itemTitle {
        color: #da261d;
      }
      .itemContent {
        color: #da261d;
      }
    }
  }
}
</style>
